import { makeAutoObservable } from "mobx";
import type { UserInterface, UserSessionInterface } from "../interfaces/interfaces";

class AuthStore {
  user: UserInterface | null = null;
  isAuthenticated = false;
  token: string | null = null;
  userSessionData: UserSessionInterface | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  login(data: {
    user: UserInterface;
    token: string;
    userSessionData?: UserSessionInterface;
  }) {
    this.user = data.user;
    this.token = data.token;
    this.userSessionData = data.userSessionData || null;
    this.isAuthenticated = true;
  }

  logout() {
    this.user = null;
    this.token = null;
    this.userSessionData = null;
    this.isAuthenticated = false;
  }
}

const authStore = new AuthStore();
export default authStore;
